import { render, staticRenderFns } from "./InfosetsMoreListMembersMenu.vue?vue&type=template&id=677e9c22&scoped=true&"
import script from "./InfosetsMoreListMembersMenu.vue?vue&type=script&lang=ts&"
export * from "./InfosetsMoreListMembersMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e9c22",
  null
  
)

export default component.exports